/**
 * Backend origin for API calls.
 * - Production build: leave REACT_APP_API_BASE_URL empty so requests stay
 *   same-origin relative (https://tillybev.com/api/…).
 * - Local CRA (`npm start` in client): defaults to the Express port.
 */
const fromEnv = process.env.REACT_APP_API_BASE_URL;
export const API_BASE_URL =
  fromEnv != null && String(fromEnv).trim() !== ''
    ? String(fromEnv).replace(/\/+$/, '')
    : process.env.NODE_ENV === 'production'
      ? ''
      : 'http://localhost:10000';

// Auth token lives in localStorage under the key exported as AUTH_TOKEN_KEY
// from utils/api.ts ("token"). Always call the API via apiFetch().